// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d4ddda56","882":"6f94f1f2","963":"9632ede3"}[chunkId] + ".chunk.js";
};